import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Input } from './styles'

const Radio = forwardRef(({
  name, onChange, defaultChecked, required, value
}, ref) => (
  <Input
    name={name}
    onChange={onChange}
    defaultChecked={defaultChecked}
    required={required}
    type="radio"
    value={value}
    ref={ref}
  />
))

export default Radio

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  defaultChecked: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.string
}

Radio.defaultProps = {
  defaultChecked: false,
  required: false,
  value: null
}